import React from 'react';
import { makeStyles, createStyles, Theme, styled } from '@material-ui/core/styles';
import { Box, Grid, Typography } from '@material-ui/core';

const HeroBlock = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2, 0),
}));

const Highlight = styled('a')({
  color: '#f15236',
  fontWeight: 600,
  wordBreak: 'break-word',
  textDecoration: 'none',
});

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      maxWidth: theme.breakpoints.values['lg'],
      margin: '0 auto',
      padding: theme.spacing(0, 3),
      color: '#423f3f',
    },
    gridLine: {
      borderBottom: '3px solid #4bb1fe',
      paddingBottom: theme.spacing(1),
    },
    paper: {
      height: 140,
      width: 100,
    },
    control: {
      padding: theme.spacing(2),
    },
    label: {
      fontSize: 24,
      fontWeight: 600,
      lineHeight: 'normal',
      color: '#737373',
    },
    title: {
      fontSize: 28,
      fontWeight: 700,
      marginBottom: 16,
    },
    text: {
      width: '100%',
      fontSize: 18,
      marginBottom: 16,
      display: 'inline-block',
    },
    list: {
      padding: '0 0 16px',
    },
    listItem: {
      paddingTop: 0,
      paddingBottom: 0,
    },
    listItemIcon: {
      minWidth: 32,
    },
    listItemText: {
      margin: 0,
    },
  })
);

const ResourcesBlock7: React.FC = () => {
  const classes = useStyles();

  return (
    <HeroBlock component="div">
      <Grid container className={classes.root}>
        <Grid item xs={12} className={classes.gridLine}>
          <Typography variant="h4" component="h2" className={classes.title}>
            Connect with the Microsoft Store client
          </Typography>

          <Typography variant="subtitle1" component="p" className={classes.text}>
            {`You can install the client for the current user, which doesn't require admin rights. Alternatively, your admin can install and configure the client so that all users on the device can access it.`}
            <br />
            {`Once installed, the client can be launched from the Start menu by searching for Remote Desktop.`}
          </Typography>

          <Typography variant="subtitle1" component="p" className={classes.text}>
            To get started,{' '}
            <Highlight href="https://www.microsoft.com/store/productId/9WZDNCRFJ3PS">
              download and install the client from the Microsoft Store
            </Highlight>
          </Typography>

          <Typography variant="subtitle1" component="p" className={classes.text}>
            {`Subscribe to the workspace provided by your admin to get the list of managed resources you can access on your PC.`}
          </Typography>

          <Typography variant="subtitle1" component="p" className={classes.text}>
            <ol>
              <li>
                In the Connection Center screen, tap <strong>+ Add</strong>, then tap
                <strong> Workspaces</strong>.
              </li>
              <li>
                Enter the Workspace URL into the <strong>Workspace URL</strong> field provided by
                your admin. The workspace URL can be either a URL or an email address
                <ul>
                  <li>{`If you're using a Workspace URL, use the URL your admin gave you`}</li>
                  <li>
                    {`If you're connecting from Windows Virtual Desktop, use one of the following URLs depending on which version of the service you're using: `}
                    <Highlight href="https://rdweb.wvd.microsoft.com/api/feeddiscovery/webfeeddiscovery.aspx">
                      Windows Virtual Desktop (classic)
                    </Highlight>
                    {` or `}
                    <Highlight href="https://rdweb.wvd.microsoft.com/api/arm/feeddiscovery">
                      Windows Virtual Desktop
                    </Highlight>
                  </li>
                </ul>
              </li>
              <li>
                Tap <strong>Subscribe</strong>.
              </li>
              <li>Provide your credentials when prompted.</li>
              <li>
                After subscribing, the workspaces should be displayed in the Connection Center.
              </li>
            </ol>
          </Typography>

          <Typography variant="subtitle1" component="p" className={classes.text}>
            {`Workspaces may be added, changed, or removed based on changes made by your administrator.`}
          </Typography>
        </Grid>
      </Grid>
    </HeroBlock>
  );
};

export default ResourcesBlock7;
